module.exports = __webpack_public_path__ + "img/dirt.c1e289c9.png";